import { Lang, LANGS } from '../../i18n';

/** First supported language in the browser's list; Ukrainian is "uk" in BCP 47, "ua" here. Default EN. */
export function detectLang(langs: readonly string[]): Lang {
  for (const l of langs) {
    const p = l.toLowerCase().split('-')[0]!;
    if (p === 'uk' || p === 'ua') return 'ua';
    if (p === 'pl' || p === 'ru' || p === 'en') return p;
  }
  return 'en';
}

export const isLang = (v: unknown): v is Lang => typeof v === 'string' && (LANGS as readonly string[]).includes(v);

/** Labels and order of the switch exactly as on megamotocross.pl: PL | RUS | UA | EN. */
export const LANG_LABEL: Record<Lang, string> = { pl: 'PL', ru: 'RUS', ua: 'UA', en: 'EN' };
export const LANG_ORDER: readonly Lang[] = ['pl', 'ru', 'ua', 'en'];
/** BCP 47 tag for <html lang>. */
export const LANG_TAG: Record<Lang, string> = { ua: 'uk', pl: 'pl', en: 'en', ru: 'ru' };
